import React from 'react'
import { observer } from 'mobx-react'
import CouponBgTop from '@assets/images/coupon/coupon-bg-top.png'

const CouponNotice: React.FC = props => {

  return (
    <div className="coupon-notice">
      <img src={CouponBgTop} alt="쿠폰 배경" className="coupon-bg top"/>

      <ul className="coupon-notice-list">
        <li className="coupon-notice-list--item">
          <span className="number">1</span>
          쿠폰은 복수개 입력이 가능합니다.
        </li>
        <li className="coupon-notice-list--item">
          <span className="number">2</span>
          한 줄당 1개씩 입력해 주세요.
        </li>
        <li className="coupon-notice-list--item">
          <span className="number">3</span>
          쿠폰은 띄어쓰기 없이 입력해 주세요.
        </li>
      </ul>
    </div>
  )
}

export default observer(CouponNotice)
